export default {
  noRequisition: "Ce poste n'a aucune réquisition ouverte. Ajouter une réquisition pour continuer.",
  requisitionDetails: 'Détails de la réquisition',
  partTime: 'Temps partiel',
  fullTime: 'Temps plein',
  seasonal: 'Saisonnier',
  effectiveTime: 'Date effective :',
  wages: 'Salaire indiqué dans la demande : ',
  requisitionSelectwage: ' Réquisition Salaire : ',
  seasonalEndDate: 'Date de fin:',
  shifts: 'Horaire',
  contractedHours: 'Heures contractées',
  minimum: 'Minimum',
  maximum: 'Maximum',
  guaranteedHours: 'Heures garanties',
  requisitionID: 'Réquisition',
  // offerNotes: "Notes de l'offre",
  offerNotes: `Notes internes sur l'offre`,
  notesPlaceholder: `Saisissez ici vos notes internes sur l'offre. Celles-ci ne peuvent pas être vues par le candidat.`,
  selectRequisition: `Choissisez Réquisition`,
  locationAndPositionChanged: 'Ce candidat a reçu une offre pour un poste différent que celui auquel il a appliqué.',
  conformAlert: {
    title: 'Avertissement',
    subtitle:
      'Vous êtes sur le point de changer le poste pour lequel le candidat se fait embaucher. Êtes-vous certain de vouloir faire ces changements?',
    close: 'Fermer',
    continue: 'Confirmer',
  },
  hourly: `Horaire`,
  annual: `Annuel`,
  weekly: `Hebdomadaire`,
  partTimeHoursPerWeek: 'Heures/semaine',
  couldNotLoadRequisition: 'Impossible de charger la réquisition pour le moment.',
  OPEN: 'Ouverte',
  CANCELLED: 'Annulée',
  FILLED: 'Comblée',
  PROCESSING: 'En traitement',
  associatedCandidate: 'Candidat sélectionné',
  effectiveTimeInfo: 'AppyHere commencera à recruter pour cette réquisition le {{requisitionActiveThresholdDays}}.',
  candidateRequisitionMatch: 'Chevauchement entre la disponibilité du candidat et le poste',
  compare: 'Comparaison',
  days: 'Days',
  candidateAvailability: 'Disponibilité du candidat',
  candidateAvailabilitiesInfo: "Ceci est l'intersection entre la disponibilité du candidat et les besoins du poste.",
  requisitionShifts: 'Disponibilité désirée',
  requisitionRiskDashboard: 'Aperçu des réquisitions',
  requisitionInsights: 'Détails des réquisitions',
  riskRequisitionDetailTable: {
    header: {
      requisitionId: 'Identifiant de la réquisition',
      status: 'Statut',
      createdUpdated: 'Création / Dernière modification',
      hireBy: 'Doit embaucher avant',
      locationPosition: 'Emplacement & Poste',
    },
    riskStatusText: {
      safe: 'OK',
      atRisk: 'À risque',
      overdue: 'En retard',
    },
    overdueDaysText: 'En retard de {{riskDays}} jours',
    riskDaysText: "{{riskDays}} jours restants pour l'embauche",
  },
  requisitionByLocation: 'Réquisitions par emplacement',
  businessRequisitionRiskStatus: {
    safe: 'OK',
    atRisk: 'À risque',
    overdue: 'En retard',
  },
  requisitionCount: {
    unfilled: 'Ouvert',
    atRisk: 'À risque',
    overdue: 'En retard',
    locationImpacted: 'Emplacements affectés',
    positionImpacted: 'Postes affectés',
  },
  pagination: {
    showingResult: "Affiche présentement {{currentItemsLength}} d'un total de {{totalItemsLength}} réquisitions",
  },
  backBtnText: 'Retour',
  salaryOffered: 'Salaire proposé au candidat :',
  noRequisitionAvailable: `Ce poste n'a aucune réquisition ouverte.`,
  recruiterNote: 'Réquisition Notes',
  additionalOffer: `Conditions supplémentaires de l'offre`,
  salaryRangeError: 'Veuillez saisir un salaire compris dans la fourchette indiquée.',
  // positionSalaryInfo: `L'offre d'emploi indique le salaire {{salaryDisplay}} `,
  hideSalaryInfo: `L'offre d'emploi ne mentionne pas de salaire.`,
  startingAtSalaryInfo: `L'offre d'emploi indique un salaire de départ de {{minSalary}}/ {{salaryUnit}}`,
  rangeSalaryInfo: `L'offre d'emploi indique une fourchette salariale allant de {{minSalary}} à {{maxSalary}}/ {{salaryUnit}}`,
  upToSalaryInfo: `L'offre d'emploi indique un salaire pouvant aller jusqu'à {{maxSalary}}/ {{salaryUnit}}`,
  fixedSalaryInfo: `L'offre d'emploi indique un salaire fixe de {{minSalary}}/ {{salaryUnit}}`,
  salaryExceptionMessage: `Votre offre propose un salaire supérieur à celui affiché aux candidats pour ce poste (maxSalary). Offrir un montant en dehors de la fourchette indiquée au candidat peut enfreindre les lois locales sur la transparence salariale et d'autres réglementations de conformité.`,
  acknowledgeText: "Je reconnais que le salaire de cette offre d'emploi dépasse la fourchette salariale affichée pour ce poste.",

  salaryFromRequisition: 'Salaire :',
  requisitionNotes: 'Notes de la réquisition',

  shiftSchedule: 'Horaire de travail',
  candidateAndPositionAvailabilityOverlap: 'Chevauchement des disponibilités du candidat et du poste',
  weekdayShift: 'Semaine',
  weekendShift: 'Fin de semaine',
  shiftHeader: {
    day: 'Jour',
    startTime: 'Heure de début',
    endTime: 'Heure de fin',
    minimumHours: 'Heures min.',
  },

  flexibilityRequirements: 'Exigences de flexibilité',
  flexibilityOutOf: '({{weekdays}} jour(s) de semaine / {{weekends}} fin(s) de semaine)',
  requirementType: 'Exigence',
  weekday: 'Semaine',
  weekend: 'Fin de semaine',
  totalRequiredStartTimes: 'Total des heures de début requises',
  totalRequiredEndTimes: 'Total des heures de fin requises',
  mandatoryDays: 'Jours obligatoires',
};
